export default __webpack_public_path__ + "static/media/simon-dwyer-bw.cfdb9466.jpeg";